import React from "react";
import styles from "./SideNav.module.css";
import {urlMapping} from '../../../config/urlMapping'
import authConfig from "../../../config/authConfig";
import Icon from "../../icon/Icon"
import SessioneUtente from "../../../sessionManager/SessioneUtente";
import history from "../../../utils/History";
import {withTranslation} from 'react-i18next';

class SideNav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentFather: null
        }
    }

   handleClick(item) {
        this.setState(prevState => (
            {[item]: !prevState[item]}
        ))
    }

  handler(children, livello, path, page) {
        const {state} = this;

        return children.map((subOption) => {
            if (!subOption.children) {

                return (

                    (subOption.url.includes(`/${path.replace("_", "-")}`)) ?

                        (
                            <li key={subOption.label}>
                                <div className={(livello == 0) ? styles.currentPage : ""}>
                                    <a className={[((livello == 0) ? "list-item large medium right-icon" : "list-item"), styles.activeItem].join(" ")}>
                                        <span>  {this.props.t(subOption.label)} </span>
                                    </a>
                                </div>

                            </li>
                        )
                        : (

                            <li key={subOption.label}>
                                <a className={[((livello == 0) ? "list-item large medium right-icon" : "list-item"), styles.testCursor].join(" ")}
                                   onClick={() => {
                                       history.push({
                                           pathname: subOption.url[0]
                                       })
                                   }}
                                ><span>{this.props.t(subOption.label)}</span></a>
                            </li>
                        )

                )
            }



            return (

                <li key={subOption.label}>  {}
                    <div onClick={() => this.handleClick(subOption.label)}
                         className={(subOption.label == page.fatherLabel) ? styles.currentPage : ""}>
                        <a className={"list-item large medium right-icon"} href={"#" + subOption.label}
                           data-toggle="collapse" aria-expanded={state[subOption.label]}
                           aria-controls={subOption.label}>
                            <span>{this.props.t(subOption.label)}</span>
                            <Icon id={"it-expand"}
                                  svgColor={"#1B7EA9"}
                                  classes={"icon-expand icon-sm right"}></Icon>
                        </a>
                    </div>
                    <ul className={(state[subOption.label]) ? "link-sublist" : "link-sublist collapse"}
                        data-target={"#" + subOption.label}>
                        {this.handler(authConfig["attivazione-auth"] ? this.filterLinks(subOption.children) : subOption.children, livello + 1, path, page)}

                    </ul>
                </li>
            )
        })
    }


    filterLinks(links) {
        let filtered = []

        let ruoliUtenteLoggato = SessioneUtente.getInstance() ? SessioneUtente.getInstance().ruoliUtente : []


        this.buildMenuList(links, ruoliUtenteLoggato, filtered);

        return filtered
    }


    buildMenuList(links, ruoliUtenteLoggato, filtered) {

        links.forEach(link => {
            let showLink = true


            if (link.children) {
                filtered.push(link)
            } else {
                let path = link.url[0] ? link.url[0].replace("/", "") : [] //todo prova
                let requiredRoles = urlMapping[path] ? urlMapping[path].requiredRoles : []

                if (requiredRoles) {
                    requiredRoles.forEach(role => {
                        if (!ruoliUtenteLoggato.includes(role)) {
                            showLink = false
                        }
                    })
                }

                if (showLink) {
                    filtered.push(link)
                }
            }


        })

    }


    render() {

        let filteredLinks = authConfig["attivazione-auth"] ? this.filterLinks(this.props.navLinks) : this.props.navLinks
        let path = window.location.pathname.split("/")[1].replace("/", "");
        let page = urlMapping[path] ? urlMapping[path] : urlMapping["default"]

        return (
            <div className={"sidebar-wrapper"}
                 style={{width: "23%", overflow: "auto", minWidth: "230px"}}>  {/** container */}
                {/* <nav> */}
                <div className={"sidebar-linklist-wrapper"}>
                    <div className={"link-list-wrapper"} id="sidebar_menu">
                        <ul className={"link-list-custom"}>
                            {this.handler(filteredLinks, 0, path, page)}
                        </ul>
                    </div>

                </div>
                <div className={styles.sidebarFooter}></div>
            </div>

        );
    }


}


export default withTranslation('common')(SideNav);
